import $ from "jquery";
//消息增加
// function addMessage(text, type) {
//     const message = $('<div class="message"></div>')
//         .addClass(type)
//         .append('<div class="message-text">' + text + '</div>');
//     $('#messagesContainer').append(message);
// }
// let isLoading = false;
// //等待响应
// function showLoading() {
//     console.log("loading")
//     isLoading = true;
//     const loadingDiv = $('<div class="loading-message"></div>').append('<div class="loading"></div>');
//     $('#messagesContainer').append(loadingDiv);
//     $('#messagesContainer').scrollTop($('#messagesContainer')[0].scrollHeight); // 滚动到底部
// }
// // 隐藏加载动画
// function hideLoading() {
//     $('.loading-message').remove();
//     isLoading = false;
//     $('#messagesContainer').scrollTop($('#messagesContainer')[0].scrollHeight); // 滚动到底部
// }

function handleIframeLoad() {
  if (isFirstLoad) {
    document.getElementById("chatbot-loading").style.display = "none";
    isFirstLoad = false;
  }
}
let isFirstLoad = true;

// 设置iframe的src
function setIframeSrc() {
  const chatbotIframe = document.getElementById("chatbot-iframe");
  // 从localStorage中获取token
  const token = localStorage.getItem("token");

  if (token) {
    // 用户已登录，加载带用户信息的URL
    chatbotIframe.src = "https://chat.hangtongshuke.com/chatbot/g7ibJ8SsxXdVwDKN";
  } else {
    // 用户未登录，加载默认URL
    chatbotIframe.src = "https://chat.hangtongshuke.com/chatbot/wbZvXUjG6sQhUOGc";
  }
}

//黑名单
const notBotUrl = [
  "platform-container",
  "heatExchangeStation",
  "systemArchitecture",
  "mobileReportCenter",
  "digitalDisplay",
  "docs",
  "homepage",
  "technologyProduct",
  "applicationScenarios",
  "solutions",
  "support",
  "partnership",
  "news",
  "aboutUs",
  "rights",
  "settled",
  "productDetail",
  "planDetails",
  "researchMove",
  "researchMobile",
];
document.addEventListener("DOMContentLoaded", () => {
  for (let i = 0; i < notBotUrl.length; i++) {
    console.log(notBotUrl[i]);
    if (window.location.href.indexOf(notBotUrl[i]) > -1) {
      return false;
    }
  }
  // 加载聊天机器人HTML
  fetch("../chatbot.html")
    .then((response) => response.text())
    .then((html) => {
      // 将HTML插入到页面中
      document.body.insertAdjacentHTML("beforeend", html);

      // 设置iframe的src
      setIframeSrc();

      // 设置聊天机器人的点击事件
      let chatbotButton = document.getElementById("chatbot-button");
      let chatbotWindow = document.getElementById("chatbot-window");
      let closeBtn = document.getElementById("close-btn");
      let chatbotLoading = document.getElementById("chatbot-loading");
      // // let sendButton = document.getElementById('send-button');
      // // let aiInput = $('#aiInput');
      // //
      // //
      chatbotButton.addEventListener("click", function () {
        console.log("chatbotButton");
        console.log("chatbotWindow", chatbotWindow.style.display);
        // window.open("http://123.166.118.9:1688/chat/gHFz6FhLDwZD48O7");
        if (chatbotWindow.style.display === "none") {
          chatbotWindow.style.display = "block";
          // 只在第一次加载时显示loading
          if (isFirstLoad) {
            chatbotLoading.style.display = "flex";
          }
        } else {
          chatbotWindow.style.display = "none";
        }
      });
      //
      closeBtn.addEventListener("click", function () {
        chatbotWindow.style.display =
          chatbotWindow.style.display === "none" ? "block" : "none";
      });

      // 获取iframe元素
      const chatbotIframe = document.getElementById("chatbot-iframe");
      chatbotIframe.addEventListener("load", function () {
        handleIframeLoad();
      });

      // sendButton.addEventListener('click', function () {
      //     let jsonData = [];
      //     if (isLoading) return;
      //     const messageText = aiInput.val().trim();
      //     if (messageText === '') return;
      //     addMessage(messageText, 'sent');
      //     $('#aiInput').val('');
      //     showLoading();//加载动作
      //     jsonData.push({ role: 'user', content: messageText });
      //     const requestBody = { history: jsonData };
      //     console.log('Sending request:', requestBody);
      //     $.ajax({
      //         url: '/hangtongai/talk',
      //         contentType: "application/json",
      //         type: 'POST',
      //         data: JSON.stringify(requestBody),
      //         success: function (response) {
      //             if (response.result !== "") {
      //                 addMessage(response.result, 'received');
      //             } else {
      //                 addMessage("网络开小差了！", 'received');
      //             }
      //             hideLoading();
      //         },
      //         error: function (xhr, status, error) {
      //             hideLoading();
      //         }
      //     });
      // });

      // // 按回车发送消息
      // $('#aiInput').keypress(function (event) {
      //     console.log("aiInput")
      //     if (event.which === 13) { // 回车键
      //         event.preventDefault();
      //         sendButton.click();
      //     }
      // });
    })
    .catch((error) => console.error("Error loading chatbot HTML:", error));
});
